import React, { useEffect, useState } from "react";

//types
import { ICompanyReviewForm } from "@performyard/models";
import { Text } from "@performyard/py-components";

//components
import Button from "../../../../../components/Button";
import Link from "../../../../../components/Link";
import ContentModal from "../../../../../components/Modal/Templates/ContentModal";
import Typography from "../../../../../components/Text";

//styles
import css from "../Forms.module.scss";

type RelatedWorkflowModalProps = {
	handleClose: () => void;
	form?: ICompanyReviewForm;
};

const RelatedWorkflowsModal = ({ handleClose, form }: RelatedWorkflowModalProps) => {
	const [cachedForm, setCachedForm] = useState<ICompanyReviewForm | null>(null);

	useEffect(() => {
		let timeout: NodeJS.Timeout | null = null;
		if (form) {
			setCachedForm(form);
		} else {
			//timeout so modal is closed before clearing form
			timeout = setTimeout(() => setCachedForm(null), 300);
		}

		return () => {
			if (timeout) {
				clearTimeout(timeout);
			}
		};
	}, [form]);

	return (
		<ContentModal
			isOpen={!!form}
			handleClose={handleClose}
			title={
				<Text
					wrap={false}
					dangerouslySetClassName={`${css.title} py-text-truncate`}
					weight="semi-bold"
					size="sub-heading"
				>
					{cachedForm?.name || ""}
				</Text>
			}
			subTitle={
				<Typography color="neutral-5" className={css.title} weight="regular" size="paragraph-3">
					This form appears in {cachedForm?.relatedWorkflows?.length || 0} Review Template
					{cachedForm?.relatedWorkflows?.length === 1 ? "" : "s"}
				</Typography>
			}
			buttons={[
				<Button key="close" color="green" onClick={handleClose}>
					Close
				</Button>,
			]}
			wrapperClassName={css.relatedWorkflowsModal}
			contentClassName={css.content}
		>
			<div className={css.workflowList}>
				{cachedForm?.relatedWorkflows?.map((workflow, index) => (
					<div key={workflow._id.toString()} className={`${css.row} ${index % 2 !== 0 ? null : css.odd}`}>
						<Typography size="paragraph-3" weight="regular">
							{index + 1}.
						</Typography>
						<Link
							href={`/edit-review-template/${workflow._id}`}
							forceHardReload={true}
							isExternal
							className="min-w-0"
						>
							<Text
								wrap={false}
								size="paragraph-3"
								weight="regular"
								dangerouslySetClassName="py-text-truncate"
							>
								{workflow.name}
							</Text>
						</Link>
					</div>
				))}
			</div>
		</ContentModal>
	);
};

export default RelatedWorkflowsModal;
